import {
  Delete16Regular,
  Person20Regular,
  PersonSwap20Regular,
} from '@/components/Icon'

export const USERS_TABLE = [
  { id: '1', name: 'Alex Rivera', email: 'alex.rivera@company.com', role: 'Admin', seat: 'Full', status: { label: 'Active', color: 'success' }, extra: 'Teams' },
  { id: '2', name: 'Jordan Lee', email: 'jordan.lee@company.com', role: 'Member', seat: 'Standard', status: { label: 'Invited', color: 'warning' }, extra: '—' },
  { id: '3', name: 'Sam Patel', email: 'sam.patel@company.com', role: 'Member', seat: 'Standard', status: { label: 'Active', color: 'success' }, extra: 'Outlook' },
  { id: '4', name: 'Taylor Chen', email: 'taylor.chen@company.com', role: 'Viewer', seat: 'Standard', status: { label: 'Suspended', color: 'default' }, extra: '—' },
]

export const INVOICES_TABLE = [
  { id: '1', invoiceId: 'INV-2025-005', billingDate: 'Jun 1, 2025', plan: 'Business', amount: '$1,280.00', status: { label: 'Open', color: 'warning' } },
  { id: '2', invoiceId: 'INV-2025-004', billingDate: 'May 1, 2025', plan: 'Business', amount: '$1,240.00', status: { label: 'Paid', color: 'success' } },
  { id: '3', invoiceId: 'INV-2025-003', billingDate: 'Apr 1, 2025', plan: 'Business', amount: '$1,240.00', status: { label: 'Paid', color: 'success' } },
  { id: '4', invoiceId: 'INV-2025-002', billingDate: 'Mar 1, 2025', plan: 'Business', amount: '$1,180.00', status: { label: 'Paid', color: 'success' } },
  { id: '5', invoiceId: 'INV-2025-001', billingDate: 'Feb 1, 2025', plan: 'Business', amount: '$1,180.00', status: { label: 'Overdue', color: 'error' } },
  { id: '6', invoiceId: 'INV-2024-012', billingDate: 'Jan 1, 2025', plan: 'Starter', amount: '$890.00', status: { label: 'Paid', color: 'success' } },
]

export const USERS_ROW_MENU_ITEMS = [
  { id: 'view-profile', label: 'View profile', Icon: Person20Regular },
  { id: 'change-role', label: 'Change role', Icon: PersonSwap20Regular },
  { id: 'remove-access', label: 'Remove access', Icon: Delete16Regular, variant: 'danger', showDividerBefore: true },
]

